import store from '@/plugins/store';
import links from '@/constants/links';
import blacklist from '@/constants/blacklist';

import {
    event as gaEvent
} from 'vue-analytics';



const mainMiddleware = ((to, from, next) => {
    // Route to analyitics
    gaEvent('routing-from', from.fullPath);
    gaEvent('routing-to', to.fullPath);

    if (to.fullPath !== links.routes.profileOAuthSetup && !store.getters.username && store.getters.isLogged) {
        next(links.routes.profileOAuthSetup);
    } else if (to.fullPath === links.routes.profileOAuthSetup && store.getters.username && store.getters.isLogged) {
        next(links.routes.profileOverview);
    } else if (blacklist.routes.logged.includes(to.fullPath) && !store.getters.isLogged) {
        next(links.routes.login);
    } else if (blacklist.routes.admin.includes(to.fullPath) && store.getters.isLogged && !store.getters.isAdmin &&
        !store.getters.isDeveloper && !store.getters.isModerator) {
        next(links.routes.profileOverview);
    } else if (blacklist.routes.guest.includes(to.fullPath) && store.getters.isLogged) {
        next(links.routes.profileOverview);
    }

    next();
})

// Routes list
const appRoutes = () => {
    const metaList = window.Laravel.Routes;

    const listRoutes = [{
            path: links.routes.welcome,
            name: 'client.landing',
            component: () =>
                import('@/components/Layouts/LandingLayout.vue'),
            beforeEnter: mainMiddleware
        },
        {
            path: links.routes.profileOAuthSetup,
            name: 'client.complete.oauth.profile',
            component: () =>
                import('@/components/Layouts/CompleteOAuthProfileLayout.vue'),
            beforeEnter: mainMiddleware,
        },
        {
            path: links.routes.login,
            name: 'client.login',
            component: () =>
                import('@/components/Layouts/LoginLayout.vue'),
            beforeEnter: mainMiddleware,
        },
        {
            path: links.routes.register,
            name: 'client.register',
            component: () =>
                import('@/components/Layouts/RegisterLayout.vue'),
            beforeEnter: mainMiddleware,
        },
        {
            path: links.routes.resetLink,
            name: 'client.reset.link',
            component: () =>
                import('@/components/Layouts/ResetLinkLayout.vue'),
            beforeEnter: mainMiddleware,
        },
        {
            path: links.routes.resetPassword,
            name: 'client.reset.password',
            component: () =>
                import('@/components/Layouts/ResetPasswordLayout.vue'),
            beforeEnter: mainMiddleware
        },
        {
            path: links.routes.about,
            name: 'client.about',
            component: () =>
                import('@/components/Layouts/AboutLayout.vue'),
            beforeEnter: mainMiddleware
        },
        {
            path: links.routes.faq,
            name: 'client.faq',
            component: () =>
                import('@/components/Layouts/FAQLayout.vue'),
            beforeEnter: mainMiddleware
        },
        {
            path: links.routes.disenchantmentCollection,
            name: 'client.guides.disenchantment.collection',
            component: () =>
                import('@/components/Layouts/Guides/DisenchantmentCollectionLayout.vue'),
            beforeEnter: mainMiddleware
        },
        {
            path: links.routes.gift,
            name: 'client.gift',
            component: () =>
                import('@/components/Layouts/GiftLayout.vue'),
            beforeEnter: mainMiddleware,
            children: [{
                path: 'points',
                name: 'client.gift.points',
                component: () =>
                    import('@/components/Views/GiftPoints.vue'),
            }]
        },
        {
            path: links.routes.shop,
            name: 'client.shop',
            component: () => import('@/components/Layouts/ShopLayout.vue'),
            beforeEnter: mainMiddleware,
            children: [{
                    path: 'popular',
                    name: 'client.shop.popular',
                    component: () => import('@/components/Views/ShopPackList.vue'),
                },
                {
                    path: 'pet',
                    name: 'client.shop.pet',
                    component: () => import('@/components/Views/ShopPackList.vue'),
                },
                {
                    path: 'char',
                    name: 'client.shop.char',
                    component: () => import('@/components/Views/ShopPackList.vue'),
                },
                {
                    path: 'misc',
                    name: 'client.shop.misc',
                    component: () => import('@/components/Views/ShopPackList.vue'),
                },
                {
                    path: 'limited',
                    name: 'client.shop.limited',
                    component: () => import('@/components/Views/ShopPackList.vue'),
                },
                {
                    path: 'discount',
                    name: 'client.shop.discount',
                    component: () => import('@/components/Views/ShopPackList.vue'),
                },
            ]
        },
        {
            path: links.routes.guides,
            name: 'client.guides',
            component: () =>
                import('@/components/Layouts/GuidesLayout.vue'),
            beforeEnter: mainMiddleware,
        },
        {
            path: links.routes.events,
            name: 'client.events',
            component: () =>
                import('@/components/Layouts/EventsLayout.vue'),
            beforeEnter: mainMiddleware,
        },
        {
            path: links.routes.notes,
            name: 'client.notes',
            component: () =>
                import('@/components/Layouts/NotesLayout.vue'),
            beforeEnter: mainMiddleware,
        },
        {
            path: '/accessibility-statement',
            name: 'client.accessibility.statement',
            component: () =>
                import('@/components/Layouts/AccessibilityStatementLayout.vue'),
            beforeEnter: mainMiddleware,
        },
        {
            path: links.routes.checkout,
            name: 'client.checkout',
            component: () =>
                import('@/components/Layouts/CheckoutLayout.vue'),
            beforeEnter: mainMiddleware,
            children: [{
                path: 'completed',
                name: 'client.checkout.completed',
                component: () =>
                    import('@/components/Views/CheckoutCompleted.vue'),
            }, {
                path: 'cancelled',
                name: 'client.checkout.cancelled',
                component: () =>
                    import('@/components/Views/CheckoutCancelled.vue'),
            }]
        },
        {
            path: links.routes.tc,
            name: 'client.tc',
            component: () =>
                import('@/components/Layouts/TcLayout.vue'),
            children: [{
                path: 'conditions',
                name: 'client.tc.conditions',
                component: () =>
                    import('@/components/Views/TcConditions.vue'),
            }, {
                path: 'policy',
                name: 'client.tc.policy',
                component: () =>
                    import('@/components/Views/TcPolicy.vue'),
            }]
        },
        {
            path: links.routes.profile,
            component: () =>
                import('@/components/Layouts/DashboardLayout.vue'),
            name: 'client.profile',
            beforeEnter: mainMiddleware,
            children: [{
                    path: 'overview',
                    name: 'client.profile.overview',
                    component: () =>
                        import('@/components/Views/Overview.vue'),
                    props: true,
                },
                {
                    path: 'communities',
                    name: 'client.profile.communities',
                    component: () =>
                        import('@/components/Views/Communities.vue')
                },
                {
                    path: 'downloads',
                    name: 'client.profile.downloads',
                    component: () =>
                        import('@/components/Views/DownloadGames.vue')
                },
                {
                    path: 'password',
                    name: 'client.profile.change.password',
                    component: () =>
                        import('@/components/Views/ChangePassword.vue')
                },
                {
                    path: 'transactions',
                    name: 'client.profile.transactions',
                    component: () =>
                        import('@/components/Views/TransactionsList.vue')
                }, {
                    path: 'packs/transactions',
                    name: 'client.profile.packs.transactions',
                    component: () =>
                        import('@/components/Views/PackTransactionsList.vue')
                },
                {
                    path: 'settings',
                    name: 'client.profile.settings',
                    component: () =>
                        import('@/components/Views/Settings.vue')
                },
            ]
        },
        {
            path: '*',
            beforeEnter: (to, from, next) => { next(links.routes.welcome) }
        },
    ];

    return listRoutes.reduce((routesList, currentRoute, index) => {
        const meta = metaList[currentRoute.name]
        let children = [];

        // If we have children we repeat this
        if (currentRoute.children) {
            children = currentRoute.children.reduce((childs, currentChild, index) => {
                const childMeta = metaList[currentChild.name]

                childs.push({
                    ...currentChild,
                    meta: childMeta
                })

                return childs;
            }, [])
        }
        routesList.push({
            ...currentRoute,
            meta,
            children
        });
        return routesList;
    }, []);
}

export default appRoutes();
